import React from 'react';
import clsx from 'clsx';
import './style.less';

export const TypingIndicator: React.FC<{ className?: string }> = ({ className }) => (
  <div className={clsx(className, 'TypingIndicator')}>
    <div />
    <div />
    <div />
  </div>
);
